import { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 PUNTUACIÓN CON ESTRELLAS

    Son botones de verdad, no divs: funcionan con teclado y lectores
    de pantalla. El hover se previsualiza sin cambiar el valor.
*/

export const FieldRating = ({
    id, label, hint, error,
    value = 0, onChange,
    total = 5, isReadOnly = false, isDisabled = false,
    span = 1,
}) => {

    const [useHover, setHover] = useState(0);

    const SHOWN = useHover || Number(value) || 0;

    const IS_LOCKED = isReadOnly || isDisabled;

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__rating`} role="radiogroup"
                onMouseLeave={() => setHover(0)} >
                {
                    Array.from({ length: total }, (_, i) => i + 1).map((star) => (
                        <button key={star} type="button"
                            className={`${BLOCK}__star`} data-on={star <= SHOWN}
                            aria-label={`${star} de ${total}`} aria-checked={star === Number(value)}
                            role="radio" disabled={IS_LOCKED}
                            onMouseEnter={() => !IS_LOCKED && setHover(star)}
                            onClick={() => !IS_LOCKED && onChange?.(star)} >
                            <FaStar />
                        </button>
                    ))
                }
            </div>

        </FieldShell>
    );
};
